import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import Picture from '../../Atoms/Picture/Picture';
import spacing from '../../../theme/shared/spacing';
var Container = styled.div.withConfig({
  displayName: "Card__Container",
  componentId: "sc-15nltsw-0"
})(["display:flex;position:relative;flex-direction:column;height:100%;background:", ";"], function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return theme.color(backgroundColor);
});
var Image = styled.div.withConfig({
  displayName: "Card__Image",
  componentId: "sc-15nltsw-1"
})(["height:auto;"]);
var Copy = styled.div.withConfig({
  displayName: "Card__Copy",
  componentId: "sc-15nltsw-2"
})(["padding:", ";display:flex;flex-direction:column;"], spacing('l'));

var Card = function Card(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      imageLow = _ref2.imageLow,
      images = _ref2.images,
      image = _ref2.image,
      imageAltText = _ref2.imageAltText,
      height = _ref2.height,
      width = _ref2.width,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["backgroundColor", "imageLow", "images", "image", "imageAltText", "height", "width", "children"]);

  return React.createElement(Container, Object.assign({
    backgroundColor: backgroundColor
  }, rest), imageLow ? React.createElement(Image, null, React.createElement(Picture, {
    alt: imageAltText,
    imageLow: imageLow,
    images: images,
    image: image,
    objectFit: "cover",
    width: width,
    height: height
  })) : null, children ? React.createElement(Copy, null, children) : null);
};

Card.defaultProps = {
  backgroundColor: 'white',
  children: null,
  imageLow: null,
  images: null,
  image: null,
  imageAltText: '',
  width: '100%',
  height: '100%'
};
export default Card;